module.exports = __webpack_public_path__ + "assets/img/qyzxqr.3c003db0.jpg";